// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"FullscreenVideo_videoContainer__3r_xB","fullscreenVideo":"FullscreenVideo_fullscreenVideo__24DrQ"};